import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';

const syncModels = () => {
  return authFetch('/Adviser/OrionModelImport/SyncFromOrion', {
    method: 'POST',
  });
};

export const useSyncModelsMutation = () => {
  return useMutation(syncModels);
};
